import type { NavBarExtension } from '@pflegenavi/frontend/layout';
import { useFeatureFlag } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag, FeatureFlagStatus } from '@pflegenavi/shared/api';
import { useEmployeeIsNursingHomeAdminOrManager } from '@pflegenavi/frontend/nursing-home-context';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { Iconify } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';

export const useExpenseManagementNavConfig: () => NavBarExtension = () => {
  const expenseManagementEnabled =
    useFeatureFlag(FeatureFlag.ExpenseManagement) === FeatureFlagStatus.Enabled;

  const isAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();

  const { t } = useTranslation();

  if (!expenseManagementEnabled || !isAdminOrManager) {
    return undefined;
  }

  return {
    item: {
      icon: <Iconify icon="tabler:receipt-euro" width={24} height={24} />,
      title: t('accounting.expenses.page-title'),
      path: nhAppMainPages.EXPENSE_MANAGEMENT,
      children: [
        {
          title: t('accounting.expenses.tabs.open'),
          path: nhAppMainPages.EXPENSE_MANAGEMENT_OPEN,
        },
        {
          title: t('accounting.expenses.tabs.scheduled'),
          path: nhAppMainPages.EXPENSE_MANAGEMENT_SCHEDULED,
        },
        {
          title: t('accounting.expenses.tabs.exported'),
          path: nhAppMainPages.EXPENSE_MANAGEMENT_EXPORTED,
        },
      ],
    },
  };
};
